import React from "react";
import {Button, Modal, Row} from "antd";
import {InfoCircleOutlined, PoweroffOutlined, SettingOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";

import "./c240_header.css";
import C240MachineStatusBar from "./C240MachineStatusBar";
import {ArrowBackOutlined} from "@mui/icons-material";
import {aclPermissions, hasPermissions} from "const/ACLPermissions";
import {HTSState} from "../../utils/const";

function C240Header(props) {
    let openGateButtonEnabled = props.htsState === HTSState.HTS_AVAILABLE;
    let scheduleOpenGateDisabled = props.openGateScheduled || props.htsState === HTSState.OPENING_GATE;
    return (
        <div className="c240-header">
            <div className="settings">
                <Link to={"/c240_settings/" + props.deviceId}>
                    <SettingOutlined style={{fontSize: "32px", color: "black"}}></SettingOutlined>
                </Link>
            </div>
            <C240MachineStatusBar />
            <div className="controls">
                {
                    props.blockUI || props.blurClassName === "blur" ? null : (props.queueState['ongoing'] === null && props.queueState['queue'].length === 0 ?
                        <div>
                            <Button className="scan-btn black-scan-btn" disabled={props.blurClassName === "blur" || props.blockUI} size="medium" style={{marginLeft:'10px'}} onClick={props.openGateBtn}>
                                Open Gate
                            </Button>
                        </div>
                        :
                        <div>
                            {hasPermissions([aclPermissions.view_open_gate_now]) ?
                                (!props.gateOpen ?
                                <Button className="open-gate-btn" disabled={props.blurClassName === "blur" || props.blockUI || !openGateButtonEnabled} size="medium" style={{marginLeft:'10px'}} onClick={() => props.openGate(true)}>
                                    <b>Open gate now</b>
                                </Button>
                                :
                                <Button className="close-gate-btn" disabled={props.blurClassName === "blur" || props.blockUI || !openGateButtonEnabled} size="medium" style={{marginLeft:'10px'}} onClick={() => props.closeGate(false, false, false, true)}>
                                    <b>Close gate now</b>
                                </Button>) : null
                            }
                                <Button className="open-gate-btn" disabled={props.blurClassName === "blur" || props.blockUI || scheduleOpenGateDisabled} size="medium" style={{marginLeft:'10px'}} onClick={props.stopAfterCurrentScan}>
                                    <b>Open gate after current task</b>
                                </Button>
                                {/*<Button disabled={props.blurClassName === "blur" || props.blockUI} size="medium"  style={{marginLeft:'10px'}} onClick={props.stopNow}>*/}
                                {/*    Interrupt current task and open gate*/}
                                {/*</Button>*/}
                        </div>)
                }
                <Row style={{marginLeft: "10px"}}>
                    <Button icon={<PoweroffOutlined />} className="shutdown-scanner-btn" type={"danger"} size="medium"
                            style={{marginTop:'10px', width:"100%"}}
                            onClick={() => Modal.confirm({
                                title: 'Are you sure you want to shutdown the scanner?',
                                zIndex: 2000,
                                icon: <InfoCircleOutlined></InfoCircleOutlined>,
                                onOk: props.handleScannerShutdown,
                                onCancel() { }
                            })} >
                        Shut Down Scanner
                    </Button>
                </Row>
            </div>
        </div>
    );
}

export default C240Header;